import '!!file-loader?name=./favicon/[name].[ext]!./favicon/manifest.json';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/browserconfig.xml';

import '!!file-loader?name=./favicon/[name].[ext]!./favicon/apple-icon-57x57.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/apple-icon-60x60.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/apple-icon-72x72.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/apple-icon-76x76.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/apple-icon-114x114.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/apple-icon-120x120.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/apple-icon-144x144.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/apple-icon-152x152.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/apple-icon-180x180.png';

import '!!file-loader?name=./favicon/[name].[ext]!./favicon/favicon.ico';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/favicon-32x32.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/favicon-96x96.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/favicon-16x16.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/ms-icon-144x144.png';

import '!!file-loader?name=./favicon/[name].[ext]!./favicon/android-icon-36x36.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/android-icon-48x48.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/android-icon-72x72.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/android-icon-96x96.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/android-icon-144x144.png';
import '!!file-loader?name=./favicon/[name].[ext]!./favicon/android-icon-192x192.png';


// WEBPACK FOOTER //
// ./src/manifest.js